export const AUTH_TOKEN = "accessToken";
export const REFRESH_TOKEN = "refreshToken";
export const ID_TOKEN = "idToken";
export const CANCELLED_ORDERS_COUNT = "cancelledOrdersCount";
export const CANCELLED_ORDERS_WARNING_CLOSED = "cancelledOrdersWarningClosed";

export const isVehicleOwner = (userProfile: any) => {
  return userProfile?.user?.roles[0]?.roleCode === "VEHICLE_OWNER";
};

export const isShipper = (userProfile: any) => {
  return userProfile?.user?.roles[0]?.roleCode === "SHIPPER";
};

/**
 * Checks if a user can see contract owner column
 * Returns false if user is a vehicle owner but not a contract owner
 * Returns true otherwise
 * 
 * @param userProfile User profile object containing role and contractOwner flag
 * @returns boolean indicating if user can see contract owner data
 */
export const canSeeContractOwnerData = (userProfile: any) => {
  if (isVehicleOwner(userProfile) && !userProfile?.user?.contractOwner) {
    return false;
  }
  return true;
};
